var map = {
	"./ehr.webp": 2158,
	"./energy.webp": 85285,
	"./erp-logistics.webp": 45180,
	"./fleet.webp": 61659,
	"./lims.webp": 30998,
	"./logistics.webp": 4772,
	"./production.webp": 94050,
	"./retail-logistics.webp": 45116,
	"./route.webp": 43982,
	"./scada.webp": 41077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63905;